
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";

const Index = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white">
      {/* Header */}
      <header className="bg-white shadow-sm">
        <div className="max-w-7xl mx-auto px-4 py-4 sm:px-6 lg:px-8">
          <h1 className="text-2xl font-bold text-gray-900">A+ Elektriker & Sikring</h1>
        </div>
      </header>

      {/* Main content */}
      <main>
        <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h2 className="text-3xl font-extrabold text-gray-900 sm:text-4xl">
              Velkommen til A+ Elektriker & Sikring
            </h2>
            <p className="mt-4 text-xl text-gray-600">
              Vælg din login-type for at fortsætte
            </p>
          </div>

          <div className="mt-12 grid gap-8 sm:grid-cols-2 sm:gap-6 max-w-3xl mx-auto">
            {/* Medarbejder login */}
            <div className="relative rounded-lg border border-gray-200 bg-white p-6 shadow-sm">
              <div className="flex flex-col items-center">
                <h3 className="text-lg font-medium text-gray-900">Medarbejder</h3>
                <p className="mt-2 text-sm text-gray-500 text-center">
                  For elektrikere og andre medarbejdere
                </p>
                <Button 
                  className="mt-4 w-full"
                  onClick={() => navigate("/employee-login")}
                >
                  Medarbejder Login
                </Button>
              </div>
            </div>

            {/* Admin login */}
            <div className="relative rounded-lg border border-gray-200 bg-white p-6 shadow-sm">
              <div className="flex flex-col items-center">
                <h3 className="text-lg font-medium text-gray-900">Administrator</h3>
                <p className="mt-2 text-sm text-gray-500 text-center">
                  For systemadministratorer
                </p>
                <Button 
                  className="mt-4 w-full"
                  variant="outline"
                  onClick={() => navigate("/auth")}
                >
                  Administrator Login
                </Button>
              </div>
            </div>
          </div>

          {/* Features section */}
          <div className="mt-16">
            <h3 className="text-xl font-semibold text-gray-900 text-center mb-8">
              Systemfunktioner
            </h3>
            <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3">
              <Feature 
                title="GPS-Baseret Tidsregistrering"
                description="Automatisk registrering af arbejdstid baseret på lokation"
              />
              <Feature 
                title="Opgavestyring"
                description="Nem oversigt over dagens opgaver og projekter"
              />
              <Feature 
                title="Dokumenthåndtering"
                description="Upload og håndter dokumenter direkte i systemet"
              />
            </div>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-gray-50 mt-16">
        <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
          <p className="text-center text-gray-500 text-sm">
            © {new Date().getFullYear()} A+ Elektriker & Sikring. Alle rettigheder forbeholdes.
          </p>
        </div>
      </footer>
    </div>
  );
};

// Feature component
const Feature = ({ title, description }: { title: string; description: string }) => (
  <div className="relative rounded-lg border border-gray-200 bg-white p-6 shadow-sm">
    <h4 className="text-lg font-medium text-gray-900">{title}</h4>
    <p className="mt-2 text-sm text-gray-500">{description}</p>
  </div>
);

export default Index;
